import { match } from "ts-pattern";

import Icon from "@/components/Icon/Icon";
import { VStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";

import type { IMPORT_CSV_FORM_HASH_VALUE } from "../-constants/hash";
import { IMPORT_CSV_FORM_HASH } from "../-constants/hash";

type Props = {
  hash: string;
};

const Processing = ({ hash }: Props) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.person.importCsv.processing",
  });

  const message = match(hash as IMPORT_CSV_FORM_HASH_VALUE)
    .with(IMPORT_CSV_FORM_HASH.PREVIEW_FILE, () => t("upload"))
    .with(IMPORT_CSV_FORM_HASH.IMPORT_DATA, () => t("import"))
    .otherwise(() => t("default"));

  return (
    <div className="flex h-full w-full items-center justify-center">
      <VStack className="items-center justify-center gap-0 px-0 py-6">
        <div className="p-5">
          <Icon
            iconName="LoaderCircleIcon"
            colorVariant="neutral"
            className="h-[180px] w-[180px] animate-spin"
          />
        </div>
        <span
          className="text-neutral-muted-on-fill"
          style={{ fontSize: "var(--font-size-20)" }}
        >
          {message}
        </span>
      </VStack>
    </div>
  );
};

export default Processing;
